<template>
  <div>
    <b-row align-h="center" class="mb-2">
      <div id="pa-dimensions">
        <div class="diagram-container">
          <img :src="dimensionsImg" alt="dimensions-img" class="d-none d-md-block">
          <img :src="dimensionsImgLabeled" alt="dimensions-img-labeled" class="d-block d-md-none">

          <div class="input entry-sensor">
            <ValidationProvider rules="required" name="Sensor de entrada" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Sensor de entrada</p>
              <b-select
                v-model="detailsForm.entry_sensor"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="sensorsOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input entry-device-1">
            <ValidationProvider rules="required" name="Dispositivo de entrada" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Dispositivo de entrada</p>
              <b-select
                v-model="detailsForm.entry_device_1"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="entryExitDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input remote-device">
            <ValidationProvider rules="required" name="Dispositivo a distancia" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Dispositivo a distancia</p>
              <b-select
                v-model="detailsForm.remote_device"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="communicationDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input alerts">
            <ValidationProvider rules="required" name="Alertas" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Alertas</p>
              <b-select
                v-model="detailsForm.alerts"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="alertsOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input exit-device-1">
            <ValidationProvider rules="required" name="Dispositivo de salida 1" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Dispositivo de salida 1</p>
              <b-select
                v-model="detailsForm.exit_device_1"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="communicationDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input exit-device-2">
            <ValidationProvider rules="required" name="Dispositivo de salida 2" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Dispositivo de salida 2</p>
              <b-select
                v-model="detailsForm.exit_device_2"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="entryExitDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input exit-sensor">
            <ValidationProvider rules="required" name="Sensor de salida" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Sensor de salida</p>
              <b-select
                v-model="detailsForm.exit_sensor"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="sensorsOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>
        </div>
      </div>
    </b-row>

    <!-- dimensions sm inputs -->
    <div class="d-block d-md-none">
      <b-row class="mb-4">
        <ValidationProvider rules="required" name="Sensor de entrada" style="width: 100%" v-slot="{ valid, errors }">

          <b-form-group class="w-100">
            <template #label>
              <Label label="Sensor de entrada" :blank="detailsForm.entry_sensor" show-reset @reset="detailsForm.entry_sensor = null" />
            </template>
            <b-select
              v-model="detailsForm.entry_sensor"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="sensorsOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-4">
        <ValidationProvider rules="required" name="Dispositivo de entrada" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo de entrada" :blank="detailsForm.entry_device_1" show-reset @reset="detailsForm.entry_device_1 = null" />
            </template>
            <b-select
              v-model="detailsForm.entry_device_1"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="entryExitDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-4">
        <ValidationProvider rules="required" name="Dispositivo a distancia" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo a distancia" :blank="detailsForm.remote_device" show-reset @reset="detailsForm.remote_device = null" />
            </template>
            <b-select
              v-model="detailsForm.remote_device"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="communicationDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-4">
        <ValidationProvider rules="required" name="Alertas" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Alertas" :blank="detailsForm.alerts" show-reset @reset="detailsForm.alerts = null" />
            </template>
            <b-select
              v-model="detailsForm.alerts"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="alertsOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-4">
        <ValidationProvider rules="required" name="Dispositivo de salida 1" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo de salida 1" :blank="detailsForm.exit_device_1" show-reset @reset="detailsForm.exit_device_1 = null" />
            </template>
            <b-select
              v-model="detailsForm.exit_device_1"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="communicationDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-4">
        <ValidationProvider rules="required" name="Dispositivo de salida 2" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo de salida 2" :blank="detailsForm.exit_device_2" show-reset @reset="detailsForm.exit_device_2 = null" />
            </template>
            <b-select
              v-model="detailsForm.exit_device_2"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="entryExitDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-4">
        <ValidationProvider rules="required" name="Sensor de salida" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Sensor de salida" :blank="detailsForm.exit_sensor" show-reset @reset="detailsForm.exit_sensor = null" />
            </template>
            <b-select
              v-model="detailsForm.exit_sensor"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="sensorsOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider } from 'vee-validate'

import Label from '../../Label'
import Button from '../../../../shared/Button'

import {
  entryExitDevicesOptions,
  communicationDevicesOptions,
  sensorsOptions,
  alertsOptions,
} from '../../../../../sharedOptions/controlesAccesoModule'

export default {
  name: 'abatible',
  components: {
    Label,
    Button,
    ValidationProvider
  },
  props: {
    form: Object,
    detailsForm: Object
  },
  data () {
    return {
      dimensionsImg: require('../../../../../../assets/images/control_acceso/abatible.png'),
      dimensionsImgLabeled: require('../../../../../../assets/images/control_acceso/abatible_labeled.png'),

      entryExitDevicesOptions: entryExitDevicesOptions,
      communicationDevicesOptions: communicationDevicesOptions,
      alertsOptions: alertsOptions
    }
  },
  computed: {
    ...mapState({
      controlAcceso: state => state.configurator.configurable,
      submital: state => state.configurator.submital
    }),
    sensorsOptions() {
      return sensorsOptions.filter(option => option.value !== 'Evoloop')
    }
  }
}
</script>


<style scoped lang="scss">
  #pa-dimensions {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    .diagram-container {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 100%;
      max-width: 62.5rem;

      img {
        width: 100%;
        max-width: 920px;
        height: auto;
        align-self: center;
      }
    }

    .input {
      position: absolute;
      z-index: 10;
      min-width: 180px;
      display: flex;
      flex-direction: column;
      gap: 2px;
      background: rgba(255, 255, 255, 0.94);
      border: 1px solid rgba(0, 0, 0, 0.08);
      border-radius: 6px;
      .label {
        display: none;
        font-size: 11px;
        font-weight: 600;
        margin-bottom: 0;
        color: #666;
        text-transform: uppercase;
        letter-spacing: 0.3px;
        line-height: 1.2;
      }
    }
    // inputs
    .entry-device-1 {
      top: 5%;
      left: 47%;
    }
    .entry-sensor {
      bottom: 37%;
      left: 12%;
    }
    .remote-device {
      top: 11%;
      left: 53%;
    }
    .alerts {
      top: 21%;
      right: 3%
    }
    .exit-device-1 {
      bottom: 14%;
      left: 19%;
    }
    .exit-device-2 {
      bottom: 7%;
      left: 14%;
    }
    .exit-sensor {
      bottom: 20%;
      left: 15%;
    }

  }

  @media (max-width: 768px) {
    #pa-dimensions {
      .input {
        min-width: 0;
        width: auto;
        padding: 0px;
        border: none;
        background: rgba(255, 255, 255, 0.94);
        box-shadow: none;

        select {
          display: none
        }

        .label {
          // display: block;
          font-size: 7px;
          font-weight: 600;
          color: #333;
          white-space: nowrap;
          letter-spacing: normal;
          margin: 0;
        }

        &:hover {
          border: none;
          transform: none;
        }
      }
      // input labels
      .entry-device-1 {
        top: 5%;
        left: 44%;
      }
      .entry-sensor {
        bottom: 37%;
        left: 15%;
      }
      .remote-device {
        top: 11%;
        left: 53%;
      }
      .alerts {
        top: 22%;
        right: 8%;
      }
      .exit-device-1 {
        bottom: 15%;
        left: 19%;
      }
      .exit-device-2 {
        bottom: 8%;
        left: 14%;
      }
      .exit-sensor {
        bottom: 21%;
        left: 22%;
      }
    }
  }
</style>
